export const CLANS = {
  arashi: {
    name: 'Clã Arashi',
    motto: 'Movimento antes da força',
    description: 'Duelistas versáteis que transformam velocidade em pressão.',
    bonuses: { atk: .04, def: 0, spd: .08, hp: 0, chakra: 25, mastery: .05 },
  },
  kurogane: {
    name: 'Clã Kurogane',
    motto: 'Permanecer é vencer',
    description: 'Guardas de ferro com vida elevada e defesa superior.',
    bonuses: { atk: 0, def: .1, spd: -.03, hp: 130, chakra: 0, mastery: 0 },
  },
  tsukiyo: {
    name: 'Clã Tsukiyo',
    motto: 'A noite revela o caminho',
    description: 'Especialistas em controle de energia e golpes precisos.',
    bonuses: { atk: .07, def: 0, spd: .03, hp: 0, chakra: 70, mastery: .04 },
  },
  hayashi: {
    name: 'Clã Hayashi',
    motto: 'Toda raiz encontra água',
    description: 'Sobreviventes que recuperam energia e aprendem mais rápido.',
    bonuses: { atk: 0, def: .04, spd: 0, hp: 80, chakra: 35, mastery: .12 },
  },
};

export const AFFINITIES = {
  ember: {
    name: 'Brasa', icon: '◆', color: '#ff744d', hex: 0xff744d,
    description: 'Pressão ofensiva e queimadura contínua.',
    strongAgainst: 'gale',
    skill: { label: 'Fenda Incandescente', description: 'Explode no impacto e pode queimar.', status: 'burn' },
  },
  gale: {
    name: 'Vendaval', icon: '≋', color: '#7de8ff', hex: 0x7de8ff,
    description: 'Velocidade, cortes e perfuração de guarda.',
    strongAgainst: 'stone',
    skill: { label: 'Lâmina do Vendaval', description: 'Corte veloz que atravessa a defesa.', status: 'exposed' },
  },
  tide: {
    name: 'Maré', icon: '◒', color: '#54a8ff', hex: 0x54a8ff,
    description: 'Controle de ritmo e recuperação de energia.',
    strongAgainst: 'ember',
    skill: { label: 'Impacto da Maré', description: 'Onda concentrada que drena energia.', status: 'drain' },
  },
  stone: {
    name: 'Rocha', icon: '⬡', color: '#d6a36e', hex: 0xd6a36e,
    description: 'Defesa, contra-ataque e ruptura de postura.',
    strongAgainst: 'storm',
    skill: { label: 'Prisão Mineral', description: 'Rochas comprimem e reduzem o ataque.', status: 'weakened' },
  },
  storm: {
    name: 'Tempestade', icon: 'ϟ', color: '#c894ff', hex: 0xc894ff,
    description: 'Ataques críticos e sobrecarga elétrica.',
    strongAgainst: 'tide',
    skill: { label: 'Passo do Trovão', description: 'Investida elétrica com chance crítica.', status: 'charged' },
  },
  eclipse: {
    name: 'Eclipse', icon: '●', color: '#d9b3ff', hex: 0xd9b3ff,
    description: 'Técnicas raras que convertem dano em vitalidade.',
    strongAgainst: null,
    skill: { label: 'Pulso do Eclipse', description: 'Golpe raro que restaura parte da vida.', status: 'leech' },
  },
};

export const CHARACTERS = {
  kaito: {
    name: 'KAITO ARASHI', title: 'HERDEIRO DO VENDAVAL', price: 0, mark: 'K', clan: 'arashi', affinity: 'gale',
    description: 'Combatente equilibrado, rápido e versátil.', bonuses: { atk: 0, def: 0, spd: 0, hp: 0, chakra: 0 },
    palette: { primary: 0x1d86a5, secondary: 0x14253d, accent: 0x2edbeb, hair: 0x111b29 },
    model: { url: '/models/Warrior.gltf', scale: .96, position: [0, 0, 0] },
  },
  akari: {
    name: 'AKARI RAIJIN', title: 'HERDEIRA DA TEMPESTADE', price: 650, mark: 'A', clan: 'tsukiyo', affinity: 'storm',
    description: 'Especialista ofensiva com golpes elétricos e alta velocidade.', bonuses: { atk: .12, def: 0, spd: .1, hp: 0, chakra: 40 },
    palette: { primary: 0x6d4bb0, secondary: 0x201a39, accent: 0xf1d45b, hair: 0x202038 },
    model: { url: '/models/Ranger.gltf', scale: .96, position: [0, 0, 0] },
  },
  daichi: {
    name: 'DAICHI KUROGANE', title: 'MURALHA DE FERRO', price: 1200, mark: 'D', clan: 'kurogane', affinity: 'stone',
    description: 'Defensor resistente, feito para suportar ataques pesados.', bonuses: { atk: .04, def: .18, spd: -.04, hp: 260, chakra: 0 },
    palette: { primary: 0x4d555d, secondary: 0x191f25, accent: 0xd36d3c, hair: 0x17191c },
    model: { url: '/models/Cleric.gltf', scale: .96, position: [0, 0, 0] },
  },
  sora: {
    name: 'SORA TSUKIYO', title: 'LÂMINA DO ECLIPSE', price: 2000, mark: 'S', clan: 'tsukiyo', affinity: 'eclipse',
    description: 'Duelista lendário com grande poder e reservas de energia.', bonuses: { atk: .18, def: .08, spd: .08, hp: 120, chakra: 120 },
    palette: { primary: 0x31588e, secondary: 0x161d31, accent: 0xa6e7ff, hair: 0xd9e2ed },
    model: { url: '/models/Wizard.gltf', scale: .96, position: [0, 0, 0] },
  },
};

export const ENEMY_ARCHETYPES = {
  scout: { name: 'Batedor', affinity: 'gale', hp: .88, attack: .94, behavior: 'aggressive', modelSpec: { url: '/models/Rogue.gltf', scale: .96 } },
  guardian: { name: 'Guardião', affinity: 'stone', hp: 1.18, attack: .88, behavior: 'defensive', modelSpec: { url: '/models/Cleric.gltf', scale: .96 } },
  channeler: { name: 'Canalizador', affinity: 'tide', hp: .96, attack: 1.05, behavior: 'technical', modelSpec: { url: '/models/Monk.gltf', scale: .96 } },
  hunter: { name: 'Caçador', affinity: 'ember', hp: 1.02, attack: 1.1, behavior: 'aggressive', modelSpec: { url: '/models/Ranger.gltf', scale: .96 } },
  warden: { name: 'Regente do Eclipse', affinity: 'eclipse', hp: 2.05, attack: 1.28, behavior: 'technical', boss: true, modelSpec: { url: '/models/Wizard.gltf', scale: 1.12 } },
};

const affinityActions = (affinityId) => {
  const affinity = AFFINITIES[affinityId] || AFFINITIES.gale;
  return {
    attack: { label: 'Golpe veloz', description: 'Dano físico confiável', cost: 0, min: 175, max: 215, anim: 'attack', stats: [186, 142, 158], element: null, mastery: 0 },
    rasengan: { label: 'Esfera de Vórtice', description: 'Energia concentrada de impacto', cost: 80, min: 260, max: 310, anim: 'rasengan', stats: [236, 121, 136], element: affinityId, mastery: 1 },
    clones: { label: 'Ecos Astrais', description: 'Dois ecos reais atacam em sequência', cost: 60, min: 205, max: 250, anim: 'clones', stats: [204, 128, 190], element: affinityId, mastery: 1, hits: 3 },
    wind: { label: affinity.skill.label, description: affinity.skill.description, cost: 70, min: 235, max: 285, anim: 'wind', pierce: affinityId === 'gale', stats: [218, 118, 170], element: affinityId, mastery: 2, status: affinity.skill.status },
    guard: { label: 'Postura defensiva', description: 'Reduz o próximo dano', cost: 0, anim: 'guard', stats: [136, 220, 108], mastery: 0 },
    recharge: { label: 'Canalizar energia', description: 'Recupera energia de técnica', cost: 0, anim: 'recharge', stats: [120, 128, 128], mastery: 0 },
  };
};

export function createActions(affinityId, skillRanks = {}) {
  const actions = affinityActions(affinityId);
  return Object.fromEntries(Object.entries(actions).map(([id, action]) => {
    const rank = Math.max(1, Number(skillRanks[id]) || 1);
    const damageScale = action.min ? 1 + (rank - 1) * .09 : 1;
    return [id, {
      ...action,
      rank,
      min: action.min ? Math.round(action.min * damageScale) : action.min,
      max: action.max ? Math.round(action.max * damageScale) : action.max,
      cost: Math.max(0, action.cost - (rank - 1) * 3),
    }];
  }));
}
